"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreInput = require("../../utilities/CoreInput");
var _PostMessage = require("../../api/PostMessage");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RadioButton = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    disabled,
    label,
    value,
    readonly,
    onChange,
    id,
    name,
    checked,
    className,
    anchor,
    required
  } = props;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    _react.default.createElement("label", {
      htmlFor: id || name,
      className: (0, _classnames.default)('radio', className, {
        'is-anchor': anchor
      }) || undefined,
      disabled: disabled,
      "aria-labelledby": label,
      onClick: () => {
        onChange(value);
        _PostMessage.PostMessage.postMessageCoreEvent('radio-click', {
          id,
          name,
          value,
          checked,
          required,
          disabled,
          readonly,
          anchor,
          label
        });
      },
      onKeyUp: () => {
        onChange(value);
        _PostMessage.PostMessage.postMessageCoreEvent('radio-keyup', {
          id,
          name,
          value,
          checked,
          required,
          disabled,
          readonly,
          anchor,
          label
        });
      }
    }, /*#__PURE__*/_react.default.createElement("input", {
      ref: ref,
      type: "radio",
      id: id || name,
      name: name,
      value: value,
      defaultChecked: checked,
      readOnly: readonly,
      disabled: disabled,
      required: required
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: anchor && checked ? 'is-underlined' : undefined
    }, label))
  );
});
RadioButton.displayName = 'RadioButton';
RadioButton.propTypes = {
  className: _propTypes.default.string,
  value: _propTypes.default.string,
  label: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  readonly: _propTypes.default.bool,
  required: _propTypes.default.bool,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  checked: _propTypes.default.bool,
  id: _propTypes.default.string,
  anchor: _propTypes.default.bool
};
RadioButton.defaultProps = {
  // control: false,
};
var _default = exports.default = (0, _CoreInput.withControl)(RadioButton);
//# sourceMappingURL=RadioButton.js.map